import React from 'react';
import Icon from '@mynewsdesk/ui/lib/Icon';
import Button from '@mynewsdesk/ui/lib/Button';
import { TYPES } from '../../constants';
import classnames from 'classnames';
import './_styles.scss';

const Toast = ({ message, className, onClose, type = '' }) => (
  <div
    className={classnames(
      'mnd-toast',
      `mnd-toast--${type.toLowerCase()}`,
      className,
    )}
  >
    <div className={`mnd-toast__type mnd-toast__type--${type.toLowerCase()}`}>
      {type === TYPES.SUCCESS ? (
        <Icon icon={['fal', 'check-circle']} />
      ) : (
        <Icon icon={['fal', 'times-circle']} />
      )}
    </div>
    <div className="mnd-toast__body">
      <p>{message} </p>
    </div>
    {onClose && (
      <div className="mnd-toast__close">
        <Button onClick={onClose} data-testid="toast-close">
          <Icon icon={['far', 'times']} />
        </Button>
      </div>
    )}
  </div>
);

export default Toast;
